const emailURL = (email) => {
  if (email.endsWith('gmail.com')) {
    return 'https://gmail.com';
  } else if (email.endsWith('outlook.com')) {
    return 'https://login.live.com';
  } else if (email.endsWith('yahoo.com')) {
    return 'https://login.yahoo.com';
  } else if (email.endsWith('inbox.com')) {
    return 'https://inbox.com';
  }
  return null;
};

export default emailURL;
